<template>
    <div>
        <b-container>
            <b-row class="text-center">
                <b-col class="mt-3" sm="12" lg="5">
                    <b-img rounded="right" :src="image"/>
                </b-col>
                <b-col class="mt-3" sm="12" lg="6" offset-lg="0">
                    <Title v-if=title :title=title />
                    <TextBlock>
                        <slot/>
                    </TextBlock>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>


<script>
    import Title from "../section/title/Title";
    import TextBlock from "../section/textblock/TextBlock";
    export default {
        name: 'ImageBanner',
        components: {TextBlock, Title},
        props: {
            title: String,
            image: String
        }
    }
</script>

<style>
    .image-banner{
        margin-top: 20px;;
    }
</style>